module.exports = __webpack_public_path__ + "static/media/cluster_1.42a49b6d.webp";